import React, { Component } from 'react'
import {Controlled as CodeMirror} from 'react-codemirror2';
import {actions, connect} from 'mirrorx';
import 'simplebar';

import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/scroll/simplescrollbars';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/dialog/dialog';
import 'codemirror/addon/search/search';
import 'codemirror/addon/search/searchcursor';
import 'codemirror/addon/search/jump-to-line';
import './textarea.css';

 const styles = {
 	editor: {
    	width: '100%',
    	height: '100%',
    	maxWidth: '640px'
    }
};


 class TextArea extends Component {
 	constructor() {
 		super();
 		this.updateText = this.updateText.bind(this);
        this.state = {
            value: ''
        };
 	}

 	updateText(editor, data, value) {
 		if (this.props.editor.text!==value) {
            actions.editor.updateText(value);
            actions.editor.updateDirty(true);
 		}
        this.setState({
            value: this.props.editor.text
        })
 	}

    componentDidMount() {
        this.setState({
            value: this.props.editor.text
        })
    }

    componentWillReceiveProps(newProps) {
        let newJump = newProps.editor.temp.jump;
        if (newJump !== this.props.editor.temp.jump &&
            newJump > -1) {
            this.refs.codemirror.editor.focus();
            this.refs.codemirror.editor.scrollIntoView({
                line: newJump
            }, 96);
            this.refs.codemirror.setCursor({
                line: newJump
            });
        }
        if (this.state.value !== newProps.editor.text) {
            this.setState({
                value: newProps.editor.text
            });
        }
    }

 	render() {
 		let options = {
            lineNumbers: false,
            lineWrapping: true,
            scrollbarStyle: 'overlay',
            viewportMargin: Infinity,
            indentWithTabs: true,
        };
 		return (
 			<div style={styles.editor}>
 			<CodeMirror ref='codemirror' value={this.state.value} onBeforeChange={this.updateText} options={options} />
 			</div>
 		)
 	}
 }

export default connect(state => {
  return {editor: state.editor}
})(TextArea)


// WEBPACK FOOTER //
// ./src/components/textarea.js